







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ActividadExtendida } from '@/pantallas/Inicio/ActividadesData/fetchActividades';

@Component({})
export default class DispositivosExtendidoActividad extends Vue {
  @Prop({ required: true }) id: string;
  @Prop({ required: true }) actividadExtendida: ActividadExtendida;
}
